export default __webpack_public_path__ + "static/media/user.5d50cb22.svg";